export default function AnalyticsSvg({ size = 26, mainColor, lighterColor }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        stroke={mainColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="m1 5.77 1.333 1.334L5 4.438M1 11.435l1.333 1.333L5 10.102"
      ></path>
      <path
        stroke={lighterColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M9 3.602h6M9 8.602h6M9 13.602h6"
      ></path>
    </svg>
  );
}
